export default "__VITE_ASSET__BhQsF$NB__"